// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cascader-relation-function-config {\n  overflow-x: auto;\n}\n.cascader-relation-function-config .ant-cascader-menu-item-active {\n  color: #1890ff;\n}", ""]);
// Exports
module.exports = exports;
